import { drawRoute, removeRoute } from '../mapbox-route-tracker/utils/mapbox-draw-route-util';
import { IdType, PolylineData } from '../../../types/maps.consts';
import { Map as MapboxMap } from 'mapbox-gl';

const polylinesMap: Map<IdType, PolylineData> = new Map();

export const updatePolylines = (map: MapboxMap, polylines?: PolylineData[]) => {
	removeOldPolylines(map, polylines);

	polylines?.forEach(polyline => {
		polylinesMap.set(polyline.id, polyline);
		drawRoute(
			map,
			{ id: polyline.id, locations: polyline.path },
			polyline.color,
			polyline.strokeOpacity,
			polyline.strokeWeight
		);
	});
};

const removeOldPolylines = (map: MapboxMap, polylines?: PolylineData[]) => {
	const newPolylines = polylines ?? [];
	const allPolylinesIds = Array.from(polylinesMap.keys());
	const updatedPolylinesIds = newPolylines.map(newPolyline => newPolyline.id);
	const unusedPolylines = allPolylinesIds.filter(polyline => !updatedPolylinesIds.includes(polyline));

	unusedPolylines.forEach(id => {
		removeRoute(map, id);
	});
};
